/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Model for title generation responses.
 * @export
 * @interface ConversationTitleResponse
 */
export interface ConversationTitleResponse {
    /**
     * Generated title for the chat conversation
     * @type {string}
     * @memberof ConversationTitleResponse
     */
    title: string;
}

/**
 * Check if a given object implements the ConversationTitleResponse interface.
 */
export function instanceOfConversationTitleResponse(value: object): value is ConversationTitleResponse {
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function ConversationTitleResponseFromJSON(json: any): ConversationTitleResponse {
    return ConversationTitleResponseFromJSONTyped(json, false);
}

export function ConversationTitleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationTitleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
    };
}

export function ConversationTitleResponseToJSON(json: any): ConversationTitleResponse {
    return ConversationTitleResponseToJSONTyped(json, false);
}

export function ConversationTitleResponseToJSONTyped(value?: ConversationTitleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
    };
}

